import { useRef } from "react";
import { motion, useInView } from "motion/react";
import { useLanguage } from "../../i18n/LanguageContext";
import { translations } from "../../i18n/translations";

const silkEase = [0.22, 1, 0.36, 1] as const;

const sectionVariants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.1 } },
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: silkEase } },
};

export function Faq() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const isInView = useInView(sectionRef, { once: true, amount: 0.15 });

  const { language } = useLanguage();
  const t = translations[language].faq;

  return (
    <section className="py-24 px-6">
      <motion.div
        ref={sectionRef}
        className="max-w-3xl mx-auto"
        variants={sectionVariants}
        initial="hidden"
        animate={isInView ? "visible" : "hidden"}
      >
        <motion.h2
          className="text-3xl md:text-4xl mb-12 text-center"
          style={{ color: "var(--foreground)", fontFamily: "var(--font-display)" }}
          variants={itemVariants}
        >
          {t.heading}
        </motion.h2>

        <div className="flex flex-col gap-4">
          {t.items.map((item, i) => (
            <motion.div
              key={i}
              className="rounded-2xl p-6"
              style={{
                border: "1px solid var(--border)",
                background: "var(--surface-1)",
              }}
              variants={itemVariants}
            >
              <h3
                className="text-lg mb-2"
                style={{ fontFamily: "var(--font-display)", color: "var(--cream)" }}
              >
                {item.question}
              </h3>
              <p
                className="text-base leading-relaxed"
                style={{ color: "var(--foreground-muted)", fontFamily: "var(--font-body)" }}
              >
                {item.answer}
              </p>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </section>
  );
}
